export const CALLBACK_URL = '/payment/callback';
export const ORDER_URL = '/reconciliation/redirect-to-gateway/';
export const BOLETO_URL = '/payment/boleto';
